import React from 'react';
import { useHistory } from 'react-router-dom';
import { Pages } from 'interfaces/main';

export const REFER_AND_EARN_QUERY_PARAM = 'referandearn';

const ReferAndEarnScene: React.FunctionComponent = () => {
    const history = useHistory();

    React.useEffect(() => {
        // Redirect to My Challenges with referAndEarn query param to trigger popup
        history.replace(`/${Pages.PROP}/${Pages.PROP__MY_CHALLENGES}?${REFER_AND_EARN_QUERY_PARAM}=true`);
    }, [history]);

    return null;
};

export default React.memo(ReferAndEarnScene);
